export default window.ww.nativeBridge